/**
 * Error codes reported by the LocationController
 */
export var LocationErrorCode;
(function (LocationErrorCode) {
    /**
     * Indicates an attempt to create or rename a location with/to a name which already exists within this court system
     * and parent location.
     */
    LocationErrorCode["DuplicateLocationName"] = "location/DuplicateLocationName";
    /**
     * Indicates an attempt to create or modify an active location which belongs to an archived parent location.
     */
    LocationErrorCode["IllegalLocationStatus"] = "location/IllegalLocationStatus";
    /**
     * Indicates an attempt to associate a Location with a parent Location in a different Court System
     */
    LocationErrorCode["IllegalParentLocation"] = "location/IllegalParentLocation";
    /**
     * Indicates an attempt to associate a Location with a parent Location which does not exist
     */
    LocationErrorCode["InvalidParentLocation"] = "location/InvalidParentLocation";
    /**
     * A Location was not found
     */
    LocationErrorCode["LocationNotFound"] = "location/LocationNotFound";
})(LocationErrorCode || (LocationErrorCode = {}));
